<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span class="pointer" v-if="this.$route.params.module_type == 'contacts'" @click="BackToContactDashboard">Contact Dashboard</span>
                            <span class="pointer" v-else-if="this.$route.params.module_type == 'customers'" @click="BackToCustomerDashboard">Customers Dashboard</span>
                            <span class="pointer" v-else-if="this.$route.params.module_type == 'leads'" @click="BackToLeadDashboard">Lead Dashboard</span>
                            <span v-else>Tools</span>
                            <div>Meetings List</div>
                        </div>
                    </div>
                    <div class="d-flex mt-3 mx-4" style="flex-grow: 1;position: relative;" v-if="orderToShow == 'list'">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_meeting !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearchs"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" v-model="search_meeting" v-debounce:500ms="loadData" debounce-events="input" type="text" placeholder="Search by Meeting Name" style="border-radius: 20px 20px 20px 20px; padding-left:30px;padding-right: 10px;height: 2.9em;">
                    </div>
                    <div class="d-flex flex-wrap align-items-center margin486">
                        <button class="btn btn-new-danger btn-wide px-6 mr-4" :disabled="selectedMeetings.length < 1 || disableDelete == true || deleteMeeting == true" style="position: relative" @click="showDeleteMeeting">- Delete</button>
                        <button class="btn btn-new-primary btn-wide px-6" @click="createSchedule()">+ Schedule Meeting</button>
                        <button @click="viewContact()" v-if="this.$route.params.module_type == 'contacts'"
                            class="btn btn-des-small ml-2 mr-3 text-white" style="background:#00448b; height:30px"><i class="crmnew-user iconsize-13 iconsize pr-2" style="font-size: 14px; color: rgb(255, 255, 255);"></i>View Contact
                        </button>
                        <button @click="viewCustomer()" v-if="this.$route.params.module_type == 'customers'"
                            class="btn btn-des-small ml-2 mr-3 text-white" style="background:#00448b; height:30px"><i class="crmnew-user iconsize-13 iconsize pr-2" style="font-size: 14px; color: rgb(255, 255, 255);"></i>View Customer
                        </button>
                        <button @click="viewLead()" v-if="this.$route.params.module_type == 'leads'"
                            class="btn btn-des-small ml-2 mr-3 text-white" style="background:#00448b; height:30px"><i class="crmnew-user iconsize-13 iconsize pr-2" style="font-size: 14px; color: rgb(255, 255, 255);"></i>View Lead
                        </button>
                        <button @click="BackToContactDashboard()" v-if="this.$route.params.module_type == 'contacts'"
                            class="btn btn-dash-board ml-2 mr-3 text-capitalize" style="height:30px"><i class="icon-chevron-left iconsize-13 iconsize pr-1" style="font-size: 20px; color: #00448b !important"></i>Back To DashBorad
                        </button>
                        <button @click="BackToCustomerDashboard()" v-if="this.$route.params.module_type == 'customers'"
                            class="btn btn-dash-board ml-2 mr-3 text-capitalize" style="height:30px"><i class="icon-chevron-left iconsize-13 iconsize pr-1" style="font-size: 20px; color: #00448b !important"></i>Back To DashBorad
                        </button>
                        <button @click="BackToLeadDashboard()" v-if="this.$route.params.module_type == 'leads'"
                            class="btn btn-dash-board ml-2 mr-3 text-capitalize" style="height:30px"><i class="icon-chevron-left iconsize-13 iconsize pr-1" style="font-size: 20px; color: #00448b !important"></i>Back To DashBorad
                        </button>
                    </div>
                </div>
            </h2>
            <!-- Dropdown Multiselect Section -->
            
            <div class="table-block overflow-x-auto mt-1" style="background-color:#fff;border-radius:5px">
                <!-- Table List View -->
                <table class="schedule-list-table table-responsive w-100" style="min-height: 250px;">
                    <thead >
                        <tr>
                            <th width="3%" style="width: 10px !important;padding: 13px 18px !important">
                                <!-- <input type="checkbox" v-model="check_all" @change="checkAll" name="select_all" /> -->
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input"  v-model="check_all" @change="checkAll" name="select_all" />
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th width="2%" style="width: 10px !important;padding: 13px 18px !important"></th>
                            <th width="17%">MEETING NAME</th>
                            <th width="20%">CUSTOMER NAME</th>
                            <th width="40%">TIMESTAMP</th>
                            <th width="21%">ADD MEETING TO CREATE</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr v-if="ajaxCallInProgress">
                            <td colspan="7" class="w-1">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && meeting_data.length == 0 && search_meeting != ''" class="text-center font-weight-bold">
                            <td colspan="7" class="w-1 font-weight-bold pb-4 pt-4">
                                <div> No data found!</div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && meeting_data.length == 0 && search_meeting == ''" class="text-center font-weight-bold" style="height: 400px;">
                            <td colspan="7" class="w-1 font-weight-bold pb-4 pt-4">
                                <img src="/static/images/schedule-illus.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center"> No Meeting is scheduled.<span style="color: #00448b;" class="pointer" @click="createSchedule()"> Add here</span></div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress" v-for="(meeting, index) in meeting_data" :key="index">
                            <td width="3%" style="width: 10px !important;padding: 13px 18px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input"  @change="selectOne($event, meeting, index)" v-model="meeting.checked"
                                        name="select_one" />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td width="2%" style="width: 10px !important;padding: 13px 18px !important">
                                <div class="pointer">
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;" @click="goToEditMeeting(meeting.meeting_id)">
                                            <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td width="17%" class="pointer text-truncate" @click="goToViewDetails(meeting.meeting_id)">
                                <span style="color: #00448b;" class="text-truncate" :title="meeting.meeting_title">{{meeting.meeting_title}}</span>
                            </td>
                            <td width="20%">
                                <span>{{meeting.customer_details.customer_name}}</span>
                            </td>
                            <td width="40%">
                                <span>{{meeting.start_date.replaceAll('-', ' /')}} {{meeting.start_time}} - {{meeting.end_date.replaceAll('-', ' /')}} {{meeting.end_time}}</span>
                            </td>
                            <td width="21%">
                                <span class="text-secondary pointer">
                                    <!-- <el-tooltip class="item" effect="dark" content="Create Helpdesk Ticket" placement="top">
                                        <button class="btn btn-new-primary mr-2" style="min-width: 62px !important;border-radius: 4px;"><img src="/static/images/schedule-icon1.svg" alt="" style="width: 20px !important;"></button>
                                    </el-tooltip> -->
                                    <el-tooltip class="item" effect="dark" content="Add Follow Up" placement="top">
                                        <button class="btn btn-new-primary mr-2" style="min-width: 62px !important;border-radius: 4px;" @click="createReminder(meeting.meeting_id)"><img src="/static/images/schedule-icon2.svg" alt="" style="width: 22px !important;"></button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="Add to Call Report" placement="top">
                                        <button class="dropdown" style="background-color: #fff !important;">
                                            <a class="btn-new-primary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="min-width: 62px !important;border-radius: 4px;padding: 8px 20px !important">
                                                <img src="/static/images/schedule-icon3.svg" alt="" style="width: 17px !important;margin-left: 1px !important;">
                                            </a>
                                            <div class="dropdown-menu call-report-type-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item" v-on:click="createCallReport('External Meeting', meeting.meeting_id)">External Meeting</a>
                                                <a class="dropdown-item" v-on:click="createCallReport('Internal Meeting', meeting.meeting_id)">Internal Meeting</a>
                                                <a class="dropdown-item" v-on:click="createCallReport('Review Meeting', meeting.meeting_id)">Review Meeting</a>
                                                <a class="dropdown-item" v-on:click="createCallReport('Sales Meeting', meeting.meeting_id)">Sales Meeting</a>
                                            </div>
                                            
                                        </button>
                                        <!-- <button class="btn btn-new-primary pl-6" style="min-width: 62px !important;border-radius: 4px;" @click="createCallReport('External Meeting')"><img src="/static/images/schedule-icon3.svg" alt="" style="width: 17px !important;"></button> -->
                                    </el-tooltip>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="!ajaxCallInProgress" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                    :options="pageLimit" :close-on-select="true" v-model.number="limit"
                    :max-height="210" :allow-empty="false" :searchable="false"
                    open-direction="top" :show-labels="false" placeholder=""
                    style="width: 4.2em !important;padding-right: 10px!important;">
                </multiselect>
                <span class="page-info pr-6 fw-500 text-dark font-size-small">Per page</span>
                <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <create-meeting :lead_current_stage="lead_current_stage" :module_type="module_type" @SaveSchedule="SaveSchedule" :reference_id="reference_id" v-if="createscheduleMeeting" :meeting_data_id="meeting_data_id" :view_mode="view_mode" modal_name="createScheduleMeeting" @hideScheduleMeeting="hideScheduleMeeting"></create-meeting>
        <edit-meeting :lead_current_stage="lead_current_stage" :reference_id="reference_id" :module_type="module_type" @SaveSchedule="SaveEditSchedule" v-if="editscheduleMeeting" :meeting_data_id="meeting_data_id" :view_mode="view_mode" modal_name="EditScheduleMeeting" @hideScheduleMeeting="hideEditScheduleMeeting"></edit-meeting>
        <delete-meeting modal_name="deleteMeetings" @deleteMeetings="deleteMeetingData" @cancelDelete="cancelDelete" v-if="deleteMeeting"></delete-meeting>
        <create-reminder v-if="createReminderShow" :lead_edit_stage="lead_edit_stage" :lead_current_stage="lead_current_stage" :from_module="from_module" :meeting_type="meeting_type" :mode_id="mode_id" :recurring_id="recurring_id" :view_mode="view_mode" modal_name="createReminderPopUp" @hideCreateReminder="hideCreateReminder" @hideCreateReminderSave="hideCreateReminderSave"></create-reminder>
    </div>
</template>
<script>
import moment from 'moment';
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from '../eventBus/nav-bar-event';
import { SweetModal } from 'sweet-modal-vue';
import schedule from "../mixins/scheduleMeeting.js"
import DeleteMeeting from "./DeleteMeeting";
import contacts from '../mixins/contacts'
const CreateReminder = () => import("../Reminders/CreateReminder.vue");
const EditMeeting = () => import("./EditScheduleMeeting.vue");
const CreateMeeting = () => import("./CreateScheduleMeeting.vue");
import customer from "../mixins/customer.js"
import leads from "../mixins/leads";
export default {
    data(){
        return{
            success_msg: '',
            warning_msg: "",
            ajaxCallInProgress: false,
            limit: 10,
            skip: 0,
            pageLimit: [],
            total: 0,
            skip_temp:0,
            temp_total:0,
            count: 0,
            createscheduleMeeting: false,
            module_type: 'tools',
            meeting_data: [],
            selectedMeetings: [],
            checked: false,
            check_all: false,
            deleteMeeting: false,
            disableDelete: false,
            meeting_type: '',
            meeting_data_id:'',
            view_mode:'create',
            createReminderShow: false,
            mode_id: '',
            recurring_id: '',
            editscheduleMeeting: false,
            search_meeting: "",
            orderToShow: "list",
            reference_id: "",
            lead_current_stage: "",
            meeting_id: "",
            from_module: "",
            lead_edit_stage: "",
            lead_current_stage: ""
        }
    },
    mixins:[schedule, contacts, customer, leads],
    components: {
        HalfCircleSpinner,
        SweetModal,
        CreateMeeting,
        CreateReminder,
        EditMeeting,
        DeleteMeeting
    },
    methods:{
        BackToContactDashboard(){
            this.$router.push('/Contacts/IndividualContact_Dashboard/' + this.$route.params.id);
        },
        BackToCustomerDashboard(){
            this.$router.push('/Customers/IndividualCustomer_Dashboard/' + this.$route.params.id);
        },
        BackToLeadDashboard(){
            this.$router.go(-1);
        },
        viewContact() {
            if(this.userPermissions.contacts_business.permitted_actions.view){
                localStorage.setItem("contact_type","business")
                this.$router.push('/contacts/view_contact/' + this.$route.params.id);
            }
            else{
                this.$toasted.global.error("Permission Denied")
            }
        },
        viewCustomer(id) {
            if(this.userPermissions.customers.permitted_actions.view){
                this.$router.push('/view_customer/' + this.$route.params.id);
            }
            else{
                this.$toasted.global.error("Permission Denied")
            }
        },
        viewLead(){
            if(this.userPermissions.leads.permitted_actions.qualify){
                this.$router.push('/leads/viewLeads/' + this.$route.params.id);
            }
            else{
                this.$toasted.global.error("Permission Denied")
            } 
        },
        clearSearchs(){
            this.search_meeting = ""
            this.$refs.searchInput.focus();
            this.loadData();
        },
        loadData(){
            if(this.orderToShow == "list"){
                this.getScheduleMeeting();
            }else{
                this.getScheduleMeeting();
            }
        },
        createCallReport(category, id) {
            this.meeting_id = id
            this.$store.commit("setCallReportCategory", category);
            localStorage.setItem('meeting_id', JSON.stringify(this.meeting_id))
            if(this.$route.params.module_type == 'contacts' || this.$route.params.module_type == 'customers' || this.$route.params.module_type == 'leads' ){
                this.$router.push('/callreports/new/'+this.$route.params.module_type+'/'+this.$route.params.id);
            }else{
                this.$router.push('/callreport/new')
            }
        },
        createReminder(id){
            if(this.$route.params.module_type == 'contacts'){
                this.from_module = 'contact'
                this.recurring_id = id
            }else if(this.$route.params.module_type == 'customers'){
                this.from_module = 'customer'
                this.recurring_id = id
            }else if(this.$route.params.module_type == 'leads'){
                this.from_module = 'leads'
                this.recurring_id = id
            }else{
                this.from_module = 'tools'
                this.recurring_id = id
            }
            this.mode_id = this.$route.params.id ? this.$route.params.id : ''
            this.meeting_type = "meeting"
            this.view_mode = 'create'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminderPopUp")
            }, 500);
        },
        hideCreateReminderSave(){
            this.createReminderShow = false;
            this.mode_id = ''
            this.recurring_id = ''
            this.view_mode = 'create'
        },
        hideCreateReminder(){
            this.createReminderShow = false;
        },
        hideEditScheduleMeeting(){
            this.editscheduleMeeting = false;
        },
        SaveEditSchedule(){
            this.editscheduleMeeting = false;
            this.getScheduleMeeting()
        },
        goToEditMeeting(meeting){
            if(this.$route.params.module_type == 'contacts'){
                this.module_type = "contacts"
                this.reference_id = this.$route.params.id
            }else if(this.$route.params.module_type == 'customers'){
                this.module_type = "customers"
                this.reference_id = this.$route.params.id
            }else if(this.$route.params.module_type == 'leads'){
                this.module_type = "leads"
                this.lead_current_stage = this.$route.params.stage_name
                this.reference_id = this.$route.params.id
            }else{
                this.module_type = "tools"
            }
            this.meeting_data_id = meeting
            this.view_mode = 'edit'
            this.editscheduleMeeting = true;
            setTimeout(() => {
                this.$modal.show("EditScheduleMeeting")
            }, 500);
        },
        showDeleteMeeting() {
            this.deleteMeeting = true
            setTimeout(() => {
                this.$modal.show('deleteMeetings')
            }, 500)
        },
        deleteMeetingData(){
            this.deleteId();
        },
        cancelDelete(){
            this.deleteMeeting = false;
        },
        async deleteId() {
            this.disableDelete = true
            try {
                let params = {
                    "meeting_id": this.selectedMeetings
                };
                let response = await this.deleteScheduleMeeting(params);
                this.deleteMeeting = false
                this.success_msg = response.message;
                this.$refs.success_modal.open();
                setTimeout(() => { 
                    this.selectedMeetings = []
                    this.disableDelete = false
                    this.$refs.success_modal.close();
                    this.getScheduleMeeting();
                }, 3000);
            }
            catch(error) {
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableDelete = false;
                    this.$refs.warning_modal.close();
                    this.getScheduleMeeting();
                }, 3000);
            }
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getScheduleMeeting();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getScheduleMeeting();
        },
        firstPage() {
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.getScheduleMeeting();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total / this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getScheduleMeeting();
        },
        selectOne(event, meetings, meeting_index) {
            if(event.target.checked){
                this.selectedMeetings.push(meetings.meeting_id)
            } else {
                this.selectedMeetings.forEach((selected_meeting, selected_meeting_index) => {
                    if(selected_meeting === meetings.meeting_id){
                        this.selectedMeetings.splice(selected_meeting_index, 1)
                    }
                })
            }
            if(this.meeting_data.every(x => x.checked == true)){
                this.check_all = true;
            } else {
                this.check_all = false;
            }
        },
        checkAll(event) {
            if(event.target.checked === true){
                this.meeting_data.forEach((el_meeting, index) => {
                    if(this.meeting_data[index].checked == false){
                        this.meeting_data[index].checked = true;
                        this.selectedMeetings.push(el_meeting.meeting_id)
                    }
                })
            } else {
                this.meeting_data.forEach((el_meeting, index) => {
                    this.meeting_data[index].checked = false;
                })
                this.meeting_data.forEach((meeting_list, meeting_list_index) => {
                    this.selectedMeetings.forEach((selected_meeting, selected_meeting_index) => {
                        if(meeting_list.meeting_id == selected_meeting){
                            this.selectedMeetings.splice(selected_meeting_index, 1)
                        }
                    })
                })
            }
        },
        async getScheduleMeeting(){
            this.meeting_data= []
            this.ajaxCallInProgress = true;
            try{
                let response = []
                if(this.$route.params.module_type == 'contacts'){
                    let params = {
                        "product_name": "CRM",
                        skip: this.skip,
                        limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                        search_key: this.search_meeting,
                        "reference_id": this.$route.params.id,
                    }
                    response = await this.getContactsMeetingList(params);
                    this.ajaxCallInProgress = false;
                }else if(this.$route.params.module_type == 'customers'){
                    let params = {
                        "product_name": "CRM",
                        skip: this.skip,
                        limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                        search_key: this.search_meeting,
                        "reference_id": this.$route.params.id,
                    }
                    response = await this.getCustomerMeetingList(params);
                    this.ajaxCallInProgress = false;
                }else if(this.$route.params.module_type == 'leads'){
                    let params = {
                        "product_name": "CRM",
                        skip: this.skip,
                        limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                        search_key: this.search_meeting,
                        "reference_id": this.$route.params.id,
                        stage_name: this.$route.params.stage_name
                    }
                    response = await this.getLeadsMeetingList(params);
                    this.ajaxCallInProgress = false;
                }else{
                    let params = {
                        skip: this.skip,
                        limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                        search_key: this.search_meeting,
                        product_name: "CRM"
                    }
                    response = await this.getScheduleMeetingList(params);
                    this.ajaxCallInProgress = false;
                }
                this.meeting_data = response.response;
                this.total = response.total_count;
                if(this.meeting_data.length != 0){
                    this.meeting_data.forEach((meeting, index) => {
                        this.meeting_data[index].checked = false;
                        if(this.selectedMeetings.length){
                            this.selectedMeetings.forEach((el_selected, el_selected_index) => {
                                if(el_selected === meeting.meeting_id){
                                    this.meeting_data[index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.meeting_data.every(x => x.checked == true)){
                        this.check_all = true;
                    } else {
                        this.check_all = false;
                    }
                }
                this.ajaxCallInProgress = false
            }catch(error){
                this.ajaxCallInProgress = false
            }
            
        },
        goToViewDetails(id){
            if(this.$route.params.module_type == 'contacts'){
                this.$router.push('/contacts/schedulemeetingview/'+this.$route.params.module_type+'/'+this.$route.params.id+'/'+id);
            }else if(this.$route.params.module_type == 'customers'){
                this.$router.push('/Customers/schedulemeetingview/'+this.$route.params.module_type+'/'+this.$route.params.id+'/'+id);
            }else if(this.$route.params.module_type == 'leads'){
                this.$router.push('/leads/schedulemeetingview/'+this.$route.params.module_type+'/'+this.$route.params.id+'/'+id+'/'+this.$route.params.stage_name);
            }else{
                this.$router.push('/teams/schedulemeetingviews/'+id);
            }
        },
        SaveSchedule(){
            this.createscheduleMeeting = false;
            this.getScheduleMeeting()
        },
        hideScheduleMeeting(){
            this.createscheduleMeeting = false;
        },
        createSchedule(){
            this.view_mode = 'create'
            if(this.$route.params.module_type == 'contacts'){
                this.module_type = "contacts"
                this.reference_id = this.$route.params.id
            }else if(this.$route.params.module_type == 'customers'){
                this.module_type = "customers"
                this.reference_id = this.$route.params.id
            }else if(this.$route.params.module_type == 'leads'){
                this.module_type = "leads"
                this.lead_current_stage = this.$route.params.stage_name
                this.reference_id = this.$route.params.id
            }else{
                this.module_type = "tools"
            }
            this.createscheduleMeeting = true;
            setTimeout(() => {
                this.$modal.show("createScheduleMeeting")
            }, 500);
        },
    },
    mounted(){
        this.getScheduleMeeting();
        this.lead_current_stage = this.$route.params.stage_name
        this.lead_edit_stage = this.$route.params.stage_name
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        
    },
    created() {
       
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    watch: {
        '$route.params.module_type': function(params){
            this.getScheduleMeeting();
        },
        limit: function() {
            this.getScheduleMeeting();
        },
    },
}
</script>
<style scoped>
    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: auto;
    }
    .schedule-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 10px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .schedule-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .schedule-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .schedule-list-table tbody tr td {
        background: #fff;
        padding: 10px 10px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .schedule-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .empty-tbody{
        height: 410px;
        display: block;
        background-color: #E8EFFF;
        margin: 20px;
        text-align: center;
        padding-top:60px;
    }
    .pointer{
        cursor: pointer !important;
    }
    .cards-text {
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .team-image {
        color: #fff;
        font-weight: 500;
        font-size: 15px;
        background: #091e42;
        border-radius: 50%;
        width: 33px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-icon{
        width: 36px;
        margin-left: -12px;
    }
    .overflowing-text{
        max-width:220px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .header-outer {
        width: 100%;
        background: #00448b;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: left;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100px !important;
    }
    .btn-dash-board{
        padding: 0 10px !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        line-height: 30px !important;
        text-transform: none !important;
        font-weight: 600 !important;
        background-color: #fff;
        color: #00448b;
        box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.16) !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/ScheduleMeetingListView.vue